import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Css/Header.module.css';
import CategoriesScroll from './../../Components/Menus/CategoriesScroll';
import SelectFilter from './../../Components/Dialogs/SelectFilter';

import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import {
	normalizeStorefrontTemplate,
	STOREFRONT_TEMPLATES
} from '../../utils/storefrontTemplate';

const Header = ({ shopid, panel_type, handleOpenBackdrop, handleChangeCategoryID, setCurrentPage, goodsParams, setGoodsParams, catalogListIndex, scrollContainerRef, isVisible, setIsVisible }) => {
	const [isInputFocused, setIsInputFocused] = useState(false);
	const inputRef = useRef(null);

	const lastScrollY = useRef(0);

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;

			if (currentScrollY > lastScrollY.current && currentScrollY > 150) {
				setIsVisible(false);
			} else {
				setIsVisible(true);
			}

			lastScrollY.current = currentScrollY;
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const { t } = useTranslation();

	const ShopSession = useSelector(state => state.shop.shop.settings);
	const storefrontTemplate = normalizeStorefrontTemplate(ShopSession.storefront_template);
	const isBoutiqueTemplate = storefrontTemplate === STOREFRONT_TEMPLATES.BOUTIQUE;
	const boutiqueDisplayName = String(ShopSession.display_name || ShopSession.shop_name || 'STORE')
		.replace(/_?bot$/i, '')
		.replace(/[_-]+/g, ' ')
		.trim();

	const handleInputFocus = () => {
		setIsInputFocused(true);
		document.querySelector('.form-search-group').style.transition = 'width 0.5s ease-in-out';
		document.querySelector('.form-search-group').style.width = '100%';
	}

	const handleInputBlur = () => {
		inputRef.current?.blur();
		setIsInputFocused(false);
		const searchGroup = document.querySelector('.form-search-group');
		if (!searchGroup) {
			return;
		}
		searchGroup.style.transition = 'width 0.5s ease-in-out';
		if(panel_type) {
			searchGroup.style.width = 'calc(100% - 40px)';
		} else {
			searchGroup.style.width = 'calc(100% - 80px)';
		}
	}

	const [openFilterDialog, setOpenFilterDialog] = React.useState(false);

	const handleOpenFilterDialog = () => {
		setOpenFilterDialog(true);
	};

	const handleCloseFilterDialog = (newValue?: string) => {
		setOpenFilterDialog(false);

		if (newValue) {
			setOpenFilterDialog(false);
			setGoodsParams.setFilterSearchGoods(newValue);
		}
	};

	const bannerBlockRef = useRef(null);
	const [bannerHeight, setBannerHeight] = useState(0);

	useEffect(() => {
		if (bannerBlockRef.current) {
			setBannerHeight(bannerBlockRef.current.offsetHeight - (window.Telegram.WebApp.safeAreaInset !== undefined ? window.Telegram.WebApp.safeAreaInset.top * 2 : 0));
		}
	}, []);

	window.Telegram.WebApp.onEvent('safeAreaChanged', () => {
		setBannerHeight(bannerBlockRef.current.offsetHeight - (window.Telegram.WebApp.safeAreaInset !== undefined ? window.Telegram.WebApp.safeAreaInset.top * 2 : 0));
	});

	return (
		<>
			<header style={panel_type ? {
				top: isVisible ? '0' : `-500px`,
				transition: 'top 1s',
				position: 'fixed',
				width: '100%',
				background: "var(--tg-theme-secondary-bg-color)"
			} : {
				top: isVisible ? '0' : `-500px`,
				transition: 'top 1s',
				position: 'fixed',
				width: '100%',
				background: "var(--tg-theme-secondary-bg-color)"
			}}
				className={'paddingTopSafeArea storefront-header'}
			>
				{isBoutiqueTemplate && (
					<div className="storefront-boutique-topbar">
						<button
							type="button"
							className="storefront-boutique-topbar-action"
							onClick={() => setCurrentPage('info')}
							aria-label={t('shop')}
						>
							<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
								<path d="M4 7h16M4 12h16M4 17h16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
							</svg>
						</button>
						<strong>{boutiqueDisplayName || 'STORE'}</strong>
						<button
							type="button"
							className="storefront-boutique-topbar-action"
							onClick={() => inputRef.current?.focus()}
							aria-label={t('searchText')}
						>
							<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
								<circle cx="10.5" cy="10.5" r="5.8" fill="none" stroke="currentColor" strokeWidth="1.8" />
								<path d="m15 15 4.2 4.2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
							</svg>
						</button>
					</div>
				)}
				{
					(ShopSession.bannerUniversal !== undefined || (ShopSession.bannerDark !== undefined && ShopSession.bannerLight !== undefined)) && ShopSession.hide_banner < 1 ?
					(
							<div className={`${styles.bannerRow} storefront-banner-row`}
							 style={isInputFocused ? {marginTop: -bannerHeight, marginBottom: 0, transition: "0.5s all"} : {
								 marginTop: 0,
								 marginBottom: 6,
								 transition: "0.5s all"
							 }} id="bannerBlock" ref={bannerBlockRef}
						>
								<div className={`${styles.bannerMedia} storefront-banner-media`}>
								{
									ShopSession.bannerUniversal !== undefined && (
										<img
											src={ShopSession.bannerUniversal}
												className={`${styles.bannerImage} banner-image storefront-banner-image`}
											alt=""/>
									)
								}
								{
									ShopSession.bannerLight !== undefined && ShopSession.bannerDark !== undefined && (
										<>
											{
											window.Telegram.WebApp.colorScheme === 'dark' ? (
												<img
													src={ShopSession.bannerDark}
													className={`${styles.bannerImage} banner-image storefront-banner-image`}
													alt=""/>
											) : (
												<img
													src={ShopSession.bannerLight}
													className={`${styles.bannerImage} banner-image storefront-banner-image`}
													alt=""/>
											)
											}
										</>
									)
								}
							</div>
							{
								ShopSession.header_button_text !== undefined && ShopSession.header_button_text !== null && ShopSession.header_button_link !== null ? (
										<div className={`${styles.bannerActionWrap} storefront-banner-action-wrap`}>
										{
											ShopSession.header_button_link.includes('https://t.me/') ? (
												<a className={`btn mainButton btn-sm d-flex justify-content-center align-items-center ${styles.bannerAction} storefront-banner-action`}
											   href={ShopSession.header_button_link}
											>
													<i className={`bi bi-telegram mr-1 ${styles.telegramIcon}`}
													   style={{color: "#fff"}}></i>
													{/*{ShopSession.header_button_link.replace('https://t.me/', '@')}*/}
													{t('our_channel')}
												</a>
											) : (
												<a className={`btn mainButton btn-sm d-flex justify-content-center align-items-center ${styles.bannerAction} storefront-banner-action`}
											   href={ShopSession.header_button_link}
											>
													{/*{ShopSession.header_button_link.replace('https://t.me/', '@')}*/}
													{ShopSession.header_button_text}
												</a>
											)
										}
									</div>
								) : (
										<div className={`${styles.bannerActionWrap} storefront-banner-action-wrap`}>
										{
											ShopSession.header_button_link !== undefined && ShopSession.header_button_link !== null && ShopSession.header_button_link.includes('https://t.me/') ? (
												<a className={`btn mainButton btn-sm d-flex justify-content-center align-items-center ${styles.bannerAction} storefront-banner-action`}
											   href={ShopSession.header_button_link}
											>
													<i className={`bi bi-telegram mr-1 ${styles.telegramIcon}`}
													   style={{color: "#fff"}}></i>
													{/*{ShopSession.header_button_link.replace('https://t.me/', '@')}*/}
													{t('our_channel')}
												</a>
											) : ShopSession.usernameAdmin.includes('-') === false ? (
												<a className={`btn mainButton btn-sm d-flex justify-content-center align-items-center ${styles.bannerAction} storefront-banner-action`}
											   href={`https://t.me/${ShopSession.usernameAdmin}`}
											>
													{/*{ShopSession.header_button_link.replace('https://t.me/', '@')}*/}
													{t('contact')}
												</a>
											) : (
												<a className={`btn mainButton btn-sm d-flex justify-content-center align-items-center ${styles.bannerAction} storefront-banner-action`}
											   href={`https://t.me/${ShopSession.bot_username}`}
											>
													{/*{ShopSession.header_button_link.replace('https://t.me/', '@')}*/}
													{t('shop')}
												</a>
											)
										}
									</div>
								)
							}
						</div>
					) : null
				}
				<div
					className={`w-100 px-1 justify-content-between d-flex ${styles.searchRow} storefront-search-row`}
					id='headerBlockJS'
				>
					<div className='inputBlockPreview'>
						<div className='input-icon-container'>
							<div
								className={`form-search-group storefront-search-control ${
									isInputFocused ? 'input-focused' : ''
								}`}
								style={{
									display: 'flex',
									width: isInputFocused ? '100%' : (panel_type ? 'calc(100% - 40px)' : 'calc(100% - 80px)'),
									transition: 'width 0.5s ease-in-out'
								}}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 24 24'
									className='input-icon'
								>
									<path
										fill='currentColor'
										d='M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z'
									/>
								</svg>
								<input
									type='text'
									className='form-control form-control-no-border custom-input'
									id='searchInput'
									placeholder={t('searchText')}
									onFocus={handleInputFocus}
									ref={inputRef}
									style={{background: "var(--tg-theme-secondary-bg-color)"}}
									onInput={(e) => setGoodsParams.setTextSearchGoods(e.target.value)}
								/>
							</div>

							<div
								style={{
									display: 'flex',
									position: 'absolute',
									marginLeft: isInputFocused ? '100%' : (panel_type ? ("calc(100% - 55px)") : ("calc(100% - 95px)")),
									transition: 'margin-left 0.5s ease-in-out',
								}}
							>
								<span className='btn header-icon' id='openFilter'
									  onClick={() => setOpenFilterDialog(true)}>
									<i className='bi bi-filter'></i>
								</span>
								{
									!panel_type && (
										<span
											className='btn header-icon mr-2 pl-1'
											onClick={() => setCurrentPage('account')}
										>
											<i className='bi bi-person'></i>
										</span>
									)
								}
							</div>
						</div>
					</div>
				</div>

				{
					goodsParams.catalogID > 0 && (
						<div style={{maxHeight: 25}}
							 className='w-100 pl-2 mt-1 d-flex align-items-center justify-content-between'
							 id='searchGoodsStat'>
							<small className="d-flex align-items-center">
								{t('the_catalog')}: <b> {catalogListIndex.find(catalog => catalog.id === goodsParams.catalogID).title}</b>
							</small>
							<i onClick={() => setGoodsParams.setCatalogID(0)} className="p-2">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									 className="bi bi-x-lg" viewBox="0 0 16 16">
									<path
										d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
								</svg>
							</i>
						</div>
					)
				}
				{
					goodsParams.shopIDSearchGoods !== shopid && (
						<div style={{maxHeight: 25}} className='w-100 pl-2 mt-1 d-flex align-items-center justify-content-between'
							 id='searchGoodsStat'>
							<small className="d-flex align-items-center">
								{t('the_shop')}<b> {goodsParams.containerTag}</b>
							</small>
							<i onClick={() => {
								setGoodsParams.setShopIDSearchGoods(shopid);
								setGoodsParams.setContainerTag('');
							}} className="p-2">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									 className="bi bi-x-lg" viewBox="0 0 16 16">
									<path
										d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
								</svg>
							</i>
						</div>
					)
				}
				{
					ShopSession.showSearchStat && (
						<>
							{
								goodsParams.catalogID > 0 ? (
									<div className='w-100 pl-2 mt-1' id='searchGoodsStat'>
										<small>{t('totalProducts')}: {catalogListIndex.find(catalog => catalog.id === goodsParams.catalogID).item_count} {t('pcs')} • {t('addedToday')}: {catalogListIndex.find(catalog => catalog.id === goodsParams.catalogID).addedToday} {t('pcs')}</small>
									</div>
								) : (
									<div className='w-100 pl-2 mt-1' id='searchGoodsStat'>
										<small>{t('totalProducts')}: {ShopSession.countGoods} {t('pcs')} • {t('addedToday')}: {ShopSession.addedToday} {t('pcs')}</small>
									</div>
								)
							}
						</>
					)
				}
					<div className='w-100 px-1 storefront-categories-wrap' id='categoriesBlock'>
					<CategoriesScroll activeIndex={goodsParams.categoryID}
									  setActiveIndex={handleChangeCategoryID}
									  handleOpenBackdrop={handleOpenBackdrop}
									  handleChangeCategoryID={handleChangeCategoryID}/>
				</div>
				<div className={styles.categoriesGoodsGap} aria-hidden="true" />
			</header>
			{
				isInputFocused && (
					<div className={styles.searchContentModal}>
						<div className='w-100 p-2' id='categoriesBlock' style={{marginTop: `calc(50px + ${window.Telegram.WebApp.safeAreaInset.top * 2}px)`,background: "var(--tg-theme-bg-color)"}}>
							<CategoriesScroll handleInputBlur={handleInputBlur} activeIndex={goodsParams.categoryID}
											  setActiveIndex={handleChangeCategoryID} searchText={goodsParams.textSearchGoods} handleOpenBackdrop={handleOpenBackdrop} handleChangeCategoryID={handleChangeCategoryID} />
						</div>
						<div className={styles.closePopupSearchText} onClick={() => handleInputBlur()}></div>
					</div>
				)
			}
			<SelectFilter
				id="filter-menu"
				keepMounted
				open={openFilterDialog}
				onClose={handleCloseFilterDialog}
				value={goodsParams.filterSearchGoods}
				setValue={setGoodsParams.setFilterSearchGoods}
			/>
		</>
	)
}

export default Header
